import z from "zod"
import { CanonicalTopicFilterBy } from "../../insights/dtos"
import { ClusterDomainSchema } from "../../insights/response_data"
import { TimeFrameEnum, TimeFrameSchema } from "../../insights/timeFrame"

export const GetBackofficeCanonicalTopicGroupedSchema = z
  .object({
    domain: ClusterDomainSchema,
    timeFrame: TimeFrameSchema.optional().default(TimeFrameEnum.Last3Months),
    goalId: z.string().nullable().optional(),
  })
  .merge(CanonicalTopicFilterBy)

export const UpdateBackofficeCanonicalTopicBodySchema = z.object({
  companyId: z.string().transform(BigInt),
  label: z.string().optional(),
  description: z.string().optional(),
})

export const RelabelBackofficeCanonicalTopicsBodySchema = z.object({
  companyId: z.string().transform(BigInt),
  canonicalTopicIds: z.array(z.string().transform(BigInt)).min(1),
})
